export const trackMOEEvent = (eventKey, attributes) => {
    try {
        if (typeof window.Moengage !== "undefined" && typeof window.Moengage.track_event !== "undefined" && eventKey) {
            if(attributes === undefined) {
                window.Moengage.track_event(eventKey);
            } else {
                window.Moengage.track_event(eventKey, attributes);
            }
        }
    } catch (error) {
        console.error(error);
    }
}

export const createMOESession = (userId) => {
    try {
        if (typeof window.Moengage !== "undefined") {
            window.Moengage.update_unique_user_id(userId);
        }
    } catch (error) {
        console.error(error);
    }
}

export const destroyMOESession = () => {
    try {
        if (typeof window.Moengage !== "undefined") {
            window.Moengage.destroy_session();
        }
    } catch (error) {
        console.error(error);
    }
}

export const setUserMOEAttribute = (key, value) => {
    try {
        if (typeof window.Moengage !== "undefined") {
            window.Moengage.add_user_attribute(key, value);
        }
    } catch (error) {
        console.error(error);
    }
}
